import Logger from '../../../utils/Logger';
const { id: module_id } = module;
const logger = Logger(module_id);

const createActionName = require('../../util').createActionName(
  'user/userInfoRequests'
);

export const VIKSU_HEALTH_CHECK_SUCCESS = createActionName(
  'VIKSU_HEALTH_CHECK_SUCCESS'
);
export const FETCHING_FROM_VIKSU = createActionName('FETCHING_FROM_VIKSU');
export const GET_VIKSU_HEALTH_FAILED = createActionName(
  'GET_VIKSU_HEALTH_FAILED'
);
export const GET_USER_INFO_REQUESTS = createActionName(
  'GET_USER_INFO_REQUESTS'
);
export const GET_USER_INFO_REQUESTS_FAILED = createActionName(
  'GET_USER_INFO_REQUESTS_FAILED'
);
export const SAVE_USER_INFO_REQUEST_ID = createActionName(
  'SAVE_USER_INFO_REQUEST_ID'
);
export const SAVE_USER_INFO_REQEUST_ID_FAILED = createActionName(
  'SAVE_USER_INFO_REQEUST_ID_FAILED'
);
export const DISMISS_SAVE_STATUS = createActionName('DISMISS_SAVE_STATUS');

export const serviceStatus = {
  OFFLINE: 'offline',
  ONLINE: 'online',
  PENDING: 'pending',
  FAILED: 'failed',
};

export const postUserInfoRequestStatus = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  UNKNOWN: 'unknown',
};

export const requestHealthCheckSuccess = () => ({
  type: VIKSU_HEALTH_CHECK_SUCCESS,
});

export const requestHealthCheckFailed = (error) => ({
  type: GET_VIKSU_HEALTH_FAILED,
  payload: { error },
});

export const getUserInfoRequest = (userInfoRequests) => ({
  type: GET_USER_INFO_REQUESTS,
  payload: { userInfoRequests },
});

export const getUserInfoRequestsFailed = (error) => ({
  type: GET_USER_INFO_REQUESTS_FAILED,
  payload: { error },
});

export const fetchingFromViksu = () => ({
  type: FETCHING_FROM_VIKSU,
});

export const postUserInfoRequestID = (status) => ({
  type: SAVE_USER_INFO_REQUEST_ID,
  payload: { status },
});

export const postUserInfoRequestIDFailed = (error) => ({
  type: SAVE_USER_INFO_REQEUST_ID_FAILED,
  payload: { error },
});

export const dismissSaveStatus = () => ({
  type: DISMISS_SAVE_STATUS,
});

export const checkViksuHealth = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(fetchingFromViksu());
    services.api
      .userInfoRequestsHealthCheck()
      .then(() => {
        resolve(dispatch(requestHealthCheckSuccess()));
      })
      .catch((error) => {
        logger.error(error);
        reject(dispatch(requestHealthCheckFailed()));
      });
  });
};

export const getUserInfoRequests = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(fetchingFromViksu());
    services.api
      .getUserInfoRequests()
      .then((data) => {
        resolve(dispatch(getUserInfoRequest(data)));
      })
      .catch((error) => {
        logger.error(error);
        reject(dispatch(getUserInfoRequestsFailed()));
      });
  });
};

export const saveUserInfoRequestID =
  (userInfoRequestID) => (dispatch, getState, services) => {
    dispatch(postUserInfoRequestID(postUserInfoRequestStatus.PENDING));
    return new Promise((resolve, reject) => {
      services.api
        .userInfoRequestsSave({ id: userInfoRequestID })
        .then(() => {
          resolve(
            dispatch(postUserInfoRequestID(postUserInfoRequestStatus.SUCCESS))
          );
        })
        .catch((err) => {
          logger.error(err);
          reject(dispatch(postUserInfoRequestIDFailed(err)));
        });
    });
  };

export const createLogEvent = (logEvent) => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    console.log('logEvent', logEvent);
    services.api
      .userInfoRequestLogEvent(logEvent)
      .then(() => {
        resolve();
      })
      .catch((err) => {
        logger.error(err);
        reject(err);
      }
      );
  }
  );
}
